module.exports = __webpack_public_path__ + "static/media/400399_01.35fdc1de.png";